import { Component } from '@angular/core';

@Component({
    selector: 'app-holiday-calculator',
    templateUrl: './holiday-calculator.component.html',
    styleUrl: './holiday-calculator.component.scss',
    standalone: false
})
export class HolidayCalculatorComponent {

}
